import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { notEmpty } from '~/infra/utils';
import { DraftStatusType } from '~/models/DraftModel';
import * as serviceModel from '~/models/service';
export function fromDTO(dto) {
    var _dto_referenceFields;
    var _dto_serviceBundles;
    return Object.assign({}, dto, {
        services: dto.services.map(serviceModel.fromDTO).filter(notEmpty),
        referenceFields: (_dto_referenceFields = dto.referenceFields) !== null && _dto_referenceFields !== void 0 ? _dto_referenceFields : undefined
    }, dto.serviceBundles ? {
        serviceBundles: {
            bundles: (_dto_serviceBundles = dto.serviceBundles) === null || _dto_serviceBundles === void 0 ? void 0 : _dto_serviceBundles.bundles.map((bundle)=>Object.assign({}, bundle, {
                    services: bundle.services.map(serviceModel.fromDTO).filter(notEmpty)
                }))
        }
    } : {});
}
export function toPreviewData(data) {
    var _ref;
    var _data_legalTermsDocuments, _data_serviceBundles;
    function serviceToDTO(s) {
        return serviceModel.toDTO(s);
    }
    return {
        id: data.id || generateUniqueId('template-preview'),
        title: data.title,
        clientContactId: null,
        isSample: false,
        lastModifiedOn: Date.now(),
        extraClause: data.extraClause,
        requirePaymentMethod: data.requirePaymentMethod,
        allowManualPayments: data.allowManualPayments,
        customNotificationText: data.customNotificationText,
        isExistingCustomer: data.isExistingCustomer,
        netTerms: data.netTerms,
        effectiveDate: data.effectiveDate,
        coverLetter: data.coverLetter,
        feeControls: {
            coverCreditCardFees: data.feeControls.coverCreditCardFees,
            coverDirectDebitFees: false
        },
        legalTermsDocuments: (_ref = (_data_legalTermsDocuments = data.legalTermsDocuments) === null || _data_legalTermsDocuments === void 0 ? void 0 : _data_legalTermsDocuments.filter(notEmpty)) !== null && _ref !== void 0 ? _ref : [],
        services: data.services.map(serviceToDTO),
        serviceBundles: ((_data_serviceBundles = data.serviceBundles) === null || _data_serviceBundles === void 0 ? void 0 : _data_serviceBundles.bundles.length) ? {
            bundles: data.serviceBundles.bundles.map((b)=>_object_spread_props(_object_spread({}, b), {
                    services: b.services.map(serviceToDTO)
                }))
        } : undefined,
        amendmentsApprovalMethod: data.amendmentsApprovalMethod,
        invoicesApprovalMethod: data.invoicesApprovalMethod,
        requestAccountantAccess: data.requestAccountantAccess,
        reviewers: [],
        expirationDate: data.expirationDate,
        customPages: data.customPages,
        referenceFields: data.referenceFields,
        status: {
            type: DraftStatusType.Active
        }
    };
}
